// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"9fe9b391","156":"6c9492be","438":"387cc76a","706":"8b12d467","726":"1f8ce403","785":"5c66c358"}[chunkId] + ".chunk.js";
};